import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
`;

export const TimeTablet = styled.div`
  margin: 0px 2px;
  padding: 6px 10px;
  min-width: 200px;
  text-align: left;
  color: #666;
  border-radius: 5px;
  font-size: 16px;
  float: right;
  background-color: #ECECEC;

  .live-text{
    color: #cc0000;
  }

  & .loading-time span {
    animation-name: ${blink};
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
`;
